import { render, staticRenderFns } from "./pay-fail.vue?vue&type=template&id=94a0182a&scoped=true"
import script from "./pay-fail.vue?vue&type=script&lang=js"
export * from "./pay-fail.vue?vue&type=script&lang=js"
import style0 from "./pay-fail.vue?vue&type=style&index=0&id=94a0182a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a0182a",
  null
  
)

export default component.exports